<template>
  <div>
    <div class="title" v-bind:class="{ active: index == 0 }">
      <i class="dropdown icon"></i>
      {{ group.name }}
    </div>
    <div class="content" v-bind:class="{ active: index == 0 }">
      <div class="ui four cards">
        <div
          class="ui card"
          v-for="(element, eidx) in group.elements || []"
          :key="eidx"
        >
          <div class="content">
            <a class="header"
              >{{ element.crs_course.name }}
              <div class="floating basic blue ui label">
                {{ element.student_count }}
              </div>
            </a>
            <div class="description">
              <div class="ui animated bulleted list">
                <div class="item">
                  {{ element.setup.day_name }}
                  {{ element.setup.schedule }}
                </div>
                <div class="item">{{ element.std_branch.name }}</div>
                <div class="item">{{ element.pfs_professor.name }}</div>
                <div class="item">{{ element.std_studying_cycle.name }}</div>
                <div class="item">{{ element.std_studying_time.name }}</div>
              </div>
              <!-- <pre>{{ element }}</pre> -->
            </div>
          </div>
          <div class="ui bottom attached basic buttons">
            <div
              data-inverted=""
              :data-tooltip="$t('edit')"
              class="ui button"
              @click="edit(element)"
            >
              <i class="ui orange edit icon"></i>
            </div>
            <div
              data-inverted=""
              :data-tooltip="$t('delete')"
              class="ui button"
              @click="remove(element)"
            >
              <i class="ui red trash icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    group: {
      type: Object,
      default: function () {
        return {};
      },
    },
    index: {
      type: Number,
    },
  },
  methods: {
    edit(element) {
      this.$emit("edit", element);
    },
    remove(element) {
      this.$emit("remove", element);
    },
  },
};
</script>
